import React, { useContext, useEffect, useState } from "react";
import TypographyItemContainer from "../../../ui/layout/page/typography-container/typography-item-container";
import Typography from "../../../ui/widgets/typography";
import TypographyContainer from "../../../ui/layout/page/typography-container/typography-base-container";
import { useMessageSource } from "react-message-source";
import CustomButton from "../../../ui/widgets/button";
import { LanguageContext } from "../../../context/languageContext";
import {
  BasicAccountApplicationDocument,
  CustomizationLinkDocument,
} from "../../../api/commercial/generated-types";
import { LeavingSwisscardModal } from "../leaving-swisscard-modal";
import { mapUserToCorrespondenceLanguage } from "../../shared/mappers";
import BasicAccountApplicationAPI from "../../../api/commercial/basic-account-application";

export interface CustomizationCardServiceProps {
  basicAccountApplication: BasicAccountApplicationDocument;
}

export const CustomizationCardService = ({
  basicAccountApplication,
}: CustomizationCardServiceProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const { language } = useContext(LanguageContext);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const [customizeCardLink, setCustomizeCardLink] =
    useState<CustomizationLinkDocument>(undefined);

  useEffect(() => {
    BasicAccountApplicationAPI.retrieveImageServiceLink(
      basicAccountApplication.applicationRef,
      mapUserToCorrespondenceLanguage(language),
    ).then((res) => setCustomizeCardLink(res));
  }, [language, basicAccountApplication]);

  if (customizeCardLink === undefined) {
    return null;
  }

  return (
    <>
      <LeavingSwisscardModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        linkToService={customizeCardLink.link}
      />
      <div className="scd-section-pusher-lg">
        <div className="scd-container-base">
          <TypographyContainer>
            <TypographyItemContainer>
              <Typography variant="h3">
                {getMessage("DocumentUpload.customization-card-service.title")}
              </Typography>
            </TypographyItemContainer>
            <TypographyItemContainer>
              <Typography variant="body1">
                {getMessage(
                  "DocumentUpload.customization-card-service.description",
                )}
              </Typography>
            </TypographyItemContainer>
            <TypographyItemContainer>
              <CustomButton onClick={() => setIsModalOpen(true)}>
                {getMessage("Button.upload")}
              </CustomButton>
            </TypographyItemContainer>
          </TypographyContainer>
        </div>
      </div>
    </>
  );
};
